import React from 'react';
import { Box, Card, CardContent, Typography, Chip, Avatar, Button, Divider } from '@mui/material';
import { brandColors } from '../../theme';

const articles = Array.from({ length: 10 }).map((_, i) => ({
  id: i + 1,
  title: `Artikel ${i + 1}: Erfolgreiche Werbemittel im Fokus`,
  excerpt:
    'Ein tiefer Einblick in Strategien, die lokale Sichtbarkeit erhöhen – inklusive Praxisbeispiele und Tipps.',
  category: i % 3 === 0 ? 'Guides' : i % 3 === 1 ? 'Case Study' : 'News',
  author: 'R2B Redaktion',
  date: '2025-09-22',
  cover: `https://picsum.photos/seed/r2b-article-${i}/1200/600`,
}));

const Articles: React.FC = () => {
  return (
    <Box>
      <Box sx={{ mb: 4, p: 3, borderRadius: 'var(--radius)', border: '1px solid var(--line)', backgroundColor: 'var(--card)' }}>
        <Typography variant="h2" sx={{ fontWeight: 800, mb: 1 }}>Artikel</Typography>
        <Typography variant="body1" sx={{ color: 'var(--muted)' }}>
          Insights, Praxisberichte und Inspiration rund um Werbemittel.
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        {articles.map((post) => (
          <Card key={post.id} sx={{ border: '1px solid var(--line)', backgroundColor: 'var(--card)', borderRadius: 'var(--radius)' }}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
              <Box
                component="img"
                src={post.cover}
                alt={post.title}
                sx={{
                  width: { xs: '100%', md: 340 },
                  height: { xs: 180, md: '100%' },
                  objectFit: 'cover',
                  borderTopLeftRadius: 'var(--radius)',
                  borderTopRightRadius: { xs: 'var(--radius)', md: 0 },
                  borderBottomLeftRadius: { xs: 0, md: 'var(--radius)' },
                }}
              />
              <CardContent sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                  <Chip label={post.category} size="small" sx={{ bgcolor: `${brandColors.electricTeal}20`, color: brandColors.electricTeal, fontWeight: 600 }} />
                  <Typography variant="caption" color="text.secondary">{post.date}</Typography>
                </Box>
                <Typography variant="h5" sx={{ fontWeight: 800, mb: 1, color: 'var(--ink)' }}>
                  {post.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {post.excerpt}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar sx={{ bgcolor: brandColors.electricTeal, width: 28, height: 28 }} />
                    <Typography variant="caption" color="text.secondary">{post.author}</Typography>
                  </Box>
                  <Button variant="text" sx={{ color: brandColors.electricTeal, fontWeight: 700, textTransform: 'none' }}>Weiterlesen →</Button>
                </Box>
              </CardContent>
            </Box>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default Articles;



